//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        uraian: "",
        tahun: "",
        keterangan: "",
        kategori: "",
        createdAt: "",
        file: null
      },
      listData: [],
      listKegiatan: [],

      page_limit: 10,
      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_lihat : false,

      UMUM: UMUM
    };
  },
  methods: {
    getView: function() {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_CAPAIAN_KEGIATAN + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          page_limit: this.page_limit,
          cari_value: this.cari_value,
          tahun: this.form.tahun,
          kategori: this.form.kategori,
          des_kel: this.$store.state.ID_DES_KEL,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.listData = res_data.data;
          this.page_last = res_data.jmlData;
          this.$store.commit("hideLoading");
          console.log(res_data);
        });
    },
    selectData : function(data){
            this.form.id = data.id;
            this.form.uraian = data.uraian;
            this.form.keterangan= data.keterangan;
            this.form.kategori = data.kategori;
            this.form.createdAt = data.createdAt;
            this.form.tahun = data.tahun;
            this.form.file = data.file;
        

    },

    cari_data: function() {
      this.page_first = 1;
      this.getView();
    },
    indexing: function(index) {
      var idx = (this.page_first - 1) * this.page_limit + index;
      return idx;
    },
    changeKategory(data){
      console.log(data)
      this.form.kategori = data
      this.getView()
    },
  },
  mounted() {
    this.$store.state.kegiatan.id = this.$route.query.id;
    // this.$store.commit('getOne')
    this.getView();
  }
};
